[
  {
    "code": "LA-AT",
    "name": "Attapu [Attopeu]"
  },
  {
    "code": "LA-BK",
    "name": "Bokèo"
  },
  {
    "code": "LA-BL",
    "name": "Bolikhamxai [Borikhane]"
  },
  {
    "code": "LA-CH",
    "name": "Champasak [Champassak]"
  },
  {
    "code": "LA-HO",
    "name": "Houaphan"
  },
  {
    "code": "LA-KH",
    "name": "Khammouan"
  },
  {
    "code": "LA-LM",
    "name": "Louang Namtha"
  },
  {
    "code": "LA-LP",
    "name": "Louangphabang [Louang Prabang]"
  },
  {
    "code": "LA-OU",
    "name": "Oudômxai [Oudomsai]"
  },
  {
    "code": "LA-PH",
    "name": "Phôngsali [Phong Saly]"
  },
  {
    "code": "LA-SL",
    "name": "Salavan [Saravane]"
  },
  {
    "code": "LA-SV",
    "name": "Savannakhét"
  },
  {
    "code": "LA-VI",
    "name": "Vientiane"
  },
  {
    "code": "LA-VT",
    "name": "Vientiane Prefecture"
  },
  {
    "code": "LA-XA",
    "name": "Xaignabouli [Sayaboury]"
  },
  {
    "code": "LA-XN",
    "name": "Xaisômboun"
  },
  {
    "code": "LA-XI",
    "name": "Xiangkhoang [Xieng Khouang]"
  },
  {
    "code": "LA-XE",
    "name": "Xékong [Sékong]"
  }
]